import React from 'react';
import './styles.scss';

type Props = {
  redirectLink?: string;
  classes?: {
    bookDemo?: string;
    button?: string;
  }
}

const BookDemo = ({
  classes = { bookDemo: '', button: '' },
  redirectLink = ''
}: Props) => {

  return (
    <div className={`${classes?.bookDemo}`}>
      <h4 className={'headerText'}>Ready to see our product in action?</h4>
      <a
        href={redirectLink}
        className={`${classes?.button}`}
        target='_blank'
      >Book a Demo</a>
    </div>
  );
}

export default BookDemo;
